import { Platform } from "utils/runtime";
import { genPrmString, PRM } from "prm";

import { sendEzspmByLink } from "tyrande";
import { tryDecodeURIComponent } from "./browser/uri";
export interface PrmParams {
	floor: number;
	position?: number;
	platform?: Platform;
}

/**
 * @param prm floor,position 统一在外部加一
 * @param floor 从1开始
 * @param position 从1开始
 */
export function genPrmLink(
	prm: { floor: number; position: string | number },
	url: string = "",
): string {
	if (url === undefined || url === "") {
		return "";
	}
	// 如MagicBanner楼层之间跳转
	if (url.startsWith("#") || url.match(/prm=(?=\d+\.)/)) {
		return url;
	}

	const postUrl = url;
	const { floor, position } = prm;

	const prmString = genPrmString({
		site: PRM.SITE.EECHIC,
		page: PRM.PAGE.TIGHTS,
		part: floor,
		content: position,
	});
	let startChat = "?";
	if (postUrl.includes("?")) {
		startChat = postUrl.endsWith("&") ? "" : "&";
	}
	return `${postUrl}${startChat}prm=${prmString}`;
}

export interface PrmParams {
	floor: number;
	position?: number;
	platform?: Platform;
}

export const sendPrmByUrl = (link: string = "") => {
	if (!link.startsWith("#")) {
		sendEzspmByLink(tryDecodeURIComponent(link), false);
	}
};
